import { MRT_RowData } from "material-react-table";
import { CustomMRTFilter } from "../mrt.types";
import { DisplayApi, filterValueOf } from "./SelectOneFromFilter";

type OneFromOneOptions<T extends MRT_RowData, SelectData> = {
    mrtProps: CustomMRTFilter<T>;
    selectedItem: SelectData | undefined;
    selectOptions: DisplayApi<SelectData>;
    newValue: SelectData | undefined | null;
};
export const onChangeOneFromOne = <T extends MRT_RowData, SelectData>(options: OneFromOneOptions<T, SelectData>) => {
    const { newValue, mrtProps, selectOptions } = options;

    if (newValue === undefined || newValue === null) {
        mrtProps.column.setFilterValue(null);
        return;
    }

    const newFilterValue = filterValueOf(selectOptions, newValue);
    mrtProps.column.setFilterValue(newFilterValue);
};
